var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerChart",staticClass:"container",attrs:{"id":"chart"}},[_c('VueApexCharts',{key:_vm.key + _vm.updateGraph,attrs:{"type":"area","options":_vm.chartOptions,"series":_vm.series,"height":_vm.height}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }